module.exports = __webpack_public_path__ + "static/triumph-of-the-city-f29194d0582eaeb5039e0e1304291803.jpg";